declare const gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);

interface RefElement<T> {
    target?: T | undefined;
    selector?: string;
}
interface Config {
    mainClass?: string;
    velocity?: number;
}

export default class Counter {
    number: string;
    wrapperElm: RefElement<HTMLElement>;
    cellNumbers: Array<CounterNumber> = [];
    minCells: number = 4;

    constructor(wrapperSelector: string, number?: number) {
        this.wrapperElm = { selector: wrapperSelector, target: document.querySelector(wrapperSelector) };
        this.number = this.checkSizeNumber(number) || this.getDataNumber();
        this.createCounter()
    }

    checkSizeNumber(number: number): string {
        let numberString = number.toString()
        if (numberString.length < this.minCells) {
            while (numberString.length < this.minCells) {
                numberString = this.fillZero(numberString)
            }
            return numberString
        }
        return numberString
    }

    fillZero(number: string): string {
        return `0${number}`
    }

    getDataNumber(): string {
        let { target } = this.wrapperElm;
        return target?.dataset.counter || ''
    }

    createCounter() {
        let { target } = this.wrapperElm;
        if (target) {
            for (let i = 0; i < this.number.length; i++) {
                let number = new CounterNumber();
                target.insertAdjacentElement('beforeend', number.getMainWrapper())
                this.cellNumbers.push(number);
            }
            gsap.set(target, { opacity: 0, translateY: 30 })
        }
    }

    showCounter() {
        let { target } = this.wrapperElm;
        let delay: number = 0;

        gsap.to(target, {
            duration: .8, opacity: 1, translateY: 0, onComplete: () => {
                this.cellNumbers.forEach((number, index) => {
                    if (this.number[index] == '0') return

                    setTimeout(() => {
                        number.updateNumber(parseInt(this.number[index]))
                    }, delay)
                    delay += 200
                })
            },
            scrollTrigger: { trigger: target, start: 'top bottom-=50px' }
        })
    }
}

class CounterNumber {
    config: Config = { mainClass: 'trnz-counter-number', velocity: 0.25 }
    mainWrapper: HTMLElement;

    constructor(config?: Config) {
        this.config = { ...this.config, ...config }
        this.init()
    }

    init() {
        this.createWrapper()
    }

    createWrapper() {
        let { mainClass } = this.config;
        let mainWrapper: HTMLElement = document.createElement('div')
        mainWrapper.classList.add(`${mainClass}`)
        mainWrapper.innerHTML = this.createNumberWrapper()
        this.mainWrapper = mainWrapper
    }

    createNumberWrapper(): string {
        let { mainClass } = this.config;
        let numberWrapper: string = '';
        for (let i = 0; i <= 9; i++) {
            let numberClasses = [`${mainClass}__box`]
            if (i == 0) numberClasses.push(`${mainClass}__box--active`)

            let markup: string =
                `<div class="${numberClasses.join(' ')}">
                    <span class="${mainClass}__up">
                        <span class="${mainClass}__up-shadow"></span>
                        <span class="${mainClass}__up-body">${i}</span>
                    </span>
                    <span class="${mainClass}__down">
                        <span class="${mainClass}__down-shadow"></span>
                        <span class="${mainClass}__down-body">${i}</span>
                    </span>
                </div>`

            numberWrapper += markup
        }
        return numberWrapper;
    }

    updateNumber(finalNumber: number) {
        let { mainClass, velocity } = this.config
        let boxNumbers = this.mainWrapper.querySelectorAll(`.${mainClass}__box`) as NodeListOf<HTMLElement>
        let mainWrapper = this.mainWrapper
        let currentNumber: number = 0;

        if (finalNumber == 0) return

        let timer = setTimeout(function increment() {
            // Se obtiene el numero actual
            let main = mainWrapper.querySelector(`.${mainClass}__box--active`) as HTMLElement
            if (main) {
                // Se obtiene el numero previo y siguiente
                let nextElm = main.nextElementSibling.classList.contains(`${mainClass}__box`) ? main.nextElementSibling : boxNumbers[0]
                let prevElm = main.previousElementSibling?.classList.contains(`${mainClass}__box`) ? main.previousElementSibling : boxNumbers[boxNumbers.length - 1]

                // Se elimina la clase activated a los elementos que la tengan
                let before = mainWrapper.querySelector(`.${mainClass}__box--activated`) as HTMLElement
                before?.classList.add(`${mainClass}__box--activated`)

                // Se agrega la clase activado al numero previo
                if (main.previousElementSibling) prevElm.classList.add(`${mainClass}__box--activated`)
                gsap.set(prevElm, { clearProps: 'zIndex' })

                // Se actualizan las clases
                main.classList.add(`${mainClass}__box--activated`)
                main.classList.remove(`${mainClass}__box--active`)
                nextElm.classList.add(`${mainClass}__box--active`)

                // Se obtiene el contenedor para el numero de arriba y abajo
                let upContainer = main.querySelector(`.${mainClass}__up`)
                let downContainer = nextElm.querySelector(`.${mainClass}__down`)

                // Se anima el numero siguiente
                let tl = gsap.timeline({
                    onComplete: () => {
                        if (currentNumber < finalNumber) timer = setTimeout(increment, velocity / 100 * 1000)
                    }
                })
                tl.set(downContainer, { rotateX: 90 })
                tl.to(upContainer, { duration: velocity, ease: 'none', rotateX: -90 })
                tl.set(nextElm, { zIndex: 4 })
                tl.to(downContainer, { duration: velocity, ease: 'none', rotateX: 0 })
            }
            currentNumber++
        }, velocity / 100 * 1000);
    }

    getMainWrapper() {
        return this.mainWrapper
    }
}